import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const Battery20FilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M9.24014 7.0998H5.64014V5.2998H9.24014V7.0998ZM18.3603 7.0998H14.7603V5.2998H18.3603V7.0998ZM6.0001 10.0398H18.0001C18.3315 10.0398 18.6001 10.3085 18.6001 10.6398V15.4398C18.6001 15.7712 18.3315 16.0398 18.0001 16.0398H6.0001C5.66873 16.0398 5.4001 15.7712 5.4001 15.4398V10.6398C5.4001 10.3085 5.66873 10.0398 6.0001 10.0398ZM3.6001 10.6398C3.6001 9.31436 4.67461 8.23984 6.0001 8.23984H18.0001C19.3256 8.23984 20.4001 9.31436 20.4001 10.6398V15.4398C20.4001 16.7653 19.3256 17.8398 18.0001 17.8398H6.0001C4.67462 17.8398 3.6001 16.7653 3.6001 15.4398V10.6398Z"
      />
      <path d="M6.6001 11.6002C6.6001 11.4014 6.76128 11.2402 6.9601 11.2402H8.7601V14.8402H6.9601C6.76127 14.8402 6.6001 14.6791 6.6001 14.4802V11.6002Z" />
    </SvgIcon>
  );
});
